<template>
    <div
        class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 auto-rows-min gap-4"
    >
        <slot></slot>
    </div>
</template>
